import React from 'react'
import "./experience.css"


function Experience() {
    return (
        <div id='experience'>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.12.1/css/all.min.css" integrity="sha256-mmgLkCYLUQbXn0B1SRqzHar6dCnv9oZFPEC1g1cwlkk=" crossorigin="anonymous" />
            <section className="section gray-bg" id="resume">
                <div className="container">
                    {/* <div className="row">
                        <div className="col-lg-6">
                            <div className="section-title">
                                <h2 id='exheading'>Experience</h2>
                                <h2>Education</h2>
                                
                            </div>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-lg-6 m-15px-tb">
                        <div className="section-title">
                            <h2>Education</h2>
                        </div>
                            <div className="resume-box">
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <i className="fas fa-user-graduate"></i>
                                        </div>
                                        <span className="time">2020 - Present</span>
                                        <h5>Lovely Professional University, Punjab</h5>
                                        <p>Pursuing Bachelor of Technology in Computer Science and Engineering from LPU</p>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="fas fa-user-graduate"></i>
                                        </div>
                                        <span className="time">2018 - 2020</span>
                                        <h5>Hope Hall Foundation School, New Delhi</h5>
                                        <p>Went to Hope Hall Foundation School, New Delhi in Class 12 for better opportunities.</p>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="fas fa-user-graduate"></i>
                                        </div>
                                        <span className="time">2007 - 2018</span>
                                        <h5>DAV Public School, Kahalgaon</h5>
                                        <p>Enjoyed my childhood and did my class 10 from my hometown school.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="col-lg-6 m-15px-tb">
                        <div className="section-title">
                            <h2>Experience</h2>
                        </div>
                            <div className="resume-box">
                                <ul>
                                    <li>
                                        <div className="icon">
                                            <i className="fas fa-briefcase"></i>
                                        </div>
                                        <span className="time">2022 - 2023</span>
                                        <h5>Social Media Head - Magnesia LPU</h5>
                                        <p>Handled social media team of Magnesia organisation, successfully conducted many events</p>
                                    </li>
                                    {/* <li>
                                        <div className="icon">
                                            <i className="fas fa-briefcase"></i>
                                        </div>
                                        <span className="time">2019 - Present</span>
                                        <h5>Art Director - Facebook Inc</h5>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <i className="fas fa-briefcase"></i>
                                        </div>
                                        <span className="time">2019 - Present</span>
                                        <h5>Art Director - Facebook Inc</h5>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Experience
